import { createTheme, ThemeProvider } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import store from './redux/store'
import reportWebVitals from './reportWebVitals'

const originalWarn = console.warn.bind(console.warn)

console.warn = (msg) =>
  !msg.toString().includes('MUI: You have provided an out-of-range value') &&
  originalWarn(msg)

const originalError = console.error.bind(console.error)

console.error = (msg) =>
  !msg
    .toString()
    .includes(
      `MUI: The Menu component doesn't accept a Fragment as a child.`
    ) && originalError(msg)

const root = createRoot(document.getElementById('root')!)

root.render(
  <BrowserRouter basename="/cc">
    <Provider store={store}>
      <ThemeProvider
        theme={createTheme({ palette: { secondary: { main: '#f50057' } } })}
      >
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
